import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const StyledEditPanel = styled('div')`
	box-sizing: border-box;
	width: 320px;
	border-radius: 13px;
	background-color: ${StyleColor.Grey50};
	box-shadow: 0 3px 35px 0 ${hexToRgba(NewStyleColor.Black, 50)};
	cursor: default;
`;

const StyledEditPanelInner = styled('div')`
	padding: 15px;
`;

const StyledIconMove = styled('div')`
	position: absolute;
	top: 16px;
	left: 7px;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	cursor: move;

	svg {
		width: 20px;
		height: 20px;
		fill: ${hexToRgba(NewStyleColor.Black, 55)};
	}
`;

export {
	StyledEditPanel,
	StyledEditPanelInner,
	StyledIconMove,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/styles.ts